import { Alert, Box, Button, Paper, Typography } from "@mui/material";
import { useI18n } from "../../src/ui/hooks/useI18n";
import { PageLayout } from "../../src/ui/layout/PageLayout";

export function AccountActivation({ title }: { title: string }) {
  const { t } = useI18n();

  return (
    <PageLayout title={t(title)}>
      <Paper sx={{ maxWidth: "sm", margin: "auto", padding: { xs: 4, sm: 6 } }}>
        <Alert severity="success">{t("verification.alertMessage")}</Alert>

        <Typography variant="body2" sx={{ my: 2, textAlign: "justify" }}>
          {t("verification.euvabeco")}
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: 2, textAlign: "justify" }}>
          {t("verification.euvabeco2")}
        </Typography>
        <Box sx={{ display: "flex", width: "100%", justifyContent: "center", mt: 4 }}>
          <Button
            href="mailto:support-grc@syadem.com?subject=Professional%20account%20activation%20request"
            variant="contained"
            disableElevation
          >
            {t("verification.cta")}
          </Button>
        </Box>
      </Paper>
    </PageLayout>
  );
}